import {
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
} from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-dialog',
  templateUrl: './filter-dialog.html',
  imports: [TranslatePipe],
})
export class filterDialog {
  //region Inputs
  // Name of the filter
  public readonly filterName = input.required<string>()
  // Whether something is selected in the filter, which keeps the button filled while the dialog is closed
  public readonly active = input(false)
  //endregion Inputs

  //region Outputs
  // Emitted each time it opens, so its content can load on first use
  public readonly opened = output()
  //endregion Outputs

  //region  Properties
  // Open state of the dialog. This is used to control the visibility of the dialog and to apply the appropriate CSS classes for styling.
  protected isDialogClosed = true
  // Reference to the component
  private readonly elementRef = inject(ElementRef<HTMLElement>)
  //endregion  Properties

  //region Methods
  toggleDialog(): void {
    this.isDialogClosed = !this.isDialogClosed
    if (!this.isDialogClosed) this.opened.emit()
  }

  closeDialog(): void {
    this.isDialogClosed = true
  }
  //endregion Methods

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // If the dialog is already closed, do nothing
    if (this.isDialogClosed) return

    const target = event.target as Node | null
    const clickedInside =
      !!target && this.elementRef.nativeElement.contains(target)

    // Close only if the click happened outside this component
    if (!clickedInside) this.closeDialog()
  }
}
